var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOxxo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 24,
    viewBox: "0 0 45 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3064_29537",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1826 0H0V24H44.1826V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3064_29537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.53467C0 2.0583 1.18573 0.860352 2.64993 0.860352H41.5266C42.9895 0.860352 44.1765 2.0583 44.1765 3.53467V20.4513C44.1765 21.9277 42.9896 23.1244 41.5266 23.1244H2.64993C1.18573 23.1244 0 21.9277 0 20.4513V3.53467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0307617 3.26462C0.0307617 1.90671 1.12247 0.805176 2.46821 0.805176H41.7466C43.0923 0.805176 44.1828 1.90671 44.1828 3.26462V3.34278H0.0307617V3.26462ZM44.1828 20.6746V20.7356C44.1828 22.0935 43.0923 23.1951 41.7466 23.1951H2.46821C1.12252 23.1951 0.0307617 22.0935 0.0307617 20.7356V20.6746H44.1828Z",
    fill: "#FBB110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5877 11.9742C30.5877 15.4117 33.3487 18.1984 36.7557 18.1984C40.1616 18.1984 42.9238 15.4118 42.9238 11.9743C42.9238 8.5354 40.1616 5.74876 36.7557 5.74876C33.3487 5.74876 30.5877 8.5354 30.5877 11.9742ZM1.17988 11.9742C1.17988 15.4117 3.94208 18.1984 7.34915 18.1984C10.7549 18.1984 13.5172 15.4118 13.5172 11.9743C13.5172 8.5354 10.7549 5.74876 7.34915 5.74876C3.94213 5.74876 1.17988 8.5354 1.17988 11.9742ZM44.1828 19.4965H13.77C14.3183 19.1082 14.8287 18.577 15.3855 17.8602L18.4836 13.8707L19.8366 15.5961L21.3423 13.5751L20.0259 11.8838L23.179 7.8223C24.1803 6.53397 22.2655 5.0197 21.2642 6.30803L18.4775 9.8982L15.6444 6.2604C14.6419 4.97576 12.7307 6.49367 13.7333 7.77951L16.9352 11.8851L13.4707 16.3459C12.2398 17.931 11.0113 19.3842 8.57274 19.4965H0.0307617V4.52148H30.2836C29.7634 4.90493 29.2725 5.41902 28.7401 6.10533L25.6432 10.0936L24.289 8.36936L22.7845 10.3904L24.1009 12.0804L20.9467 16.142C19.9466 17.4303 21.8613 18.9446 22.8615 17.6563L25.6493 14.0673L28.4824 17.7039C29.485 18.9897 31.3961 17.4719 30.3935 16.186L27.1917 12.0792L30.6561 7.61955C31.7869 6.16149 32.9164 4.8158 34.9851 4.52148H44.1828V19.4965ZM33.063 11.9742C33.063 9.91535 34.7164 8.24721 36.7557 8.24721C38.7951 8.24721 40.4473 9.91535 40.4473 11.9742C40.4473 14.0318 38.7951 15.6999 36.7557 15.6999C34.7164 15.6999 33.063 14.0318 33.063 11.9742ZM3.65639 11.9742C3.65639 9.91535 5.30982 8.24721 7.34915 8.24721C9.38723 8.24721 11.0407 9.91535 11.0407 11.9742C11.0407 14.0318 9.38728 15.6999 7.34915 15.6999C5.30982 15.6999 3.65639 14.0318 3.65639 11.9742Z",
    fill: "#E70020"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxxo);
export default __webpack_public_path__ + "static/media/oxxo.9652b8202ac6b97606b9e84bd2fa716f.svg";
export { ForwardRef as ReactComponent };